export const isLocalDevEnv = () => {
  return window?.location?.origin?.includes('localhost:4200');
};

export const isBoolean = (val) => {
  return typeof val === 'boolean';
};
